import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Payment from "./create";
import Plans from "./plans"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },

  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

function UpdateSubscription({setClose}) {
  const classes = useStyles();
  const [selectedPlan, setSelectedPlan] = useState()
  const [currentView, setCurrentView] = useState(1)
  const { currentUser = {} } = useSelector((state) => ({
    currentUser: state.currentUser,
  }));

  useEffect(()=>{
    if(new Date(currentUser.activationDate).getTime() < new Date().getTime()) {
      window.location.reload()
    }
  }, [])

  const onSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setCurrentView(2)
  }


  return (
      <div className={classes.root}>
        <CssBaseline />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            {currentView === 1 && <Plans setSelectedPlan={onSelectPlan} />}
           
            {currentView === 2 &&  <Payment selectedPlan={selectedPlan} setView={setCurrentView} setClose={setClose} />}
          </Container>
        </main>
      </div>
  );
}

export default UpdateSubscription;
